import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import { useNotification } from '../../Contexts/NotificationContext';
import Loading from '../Loading';

const SellerAddSale = ({ representanteId, onSuccess }) => {
    const { setNotification } = useNotification();
    const [mes, setMes] = useState('');
    const [quantidade, setQuantidade] = useState('');
    const [loading, setLoading] = useState(false);

    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!mes) {
            setNotification({
                type: 'error',
                message: 'Selecione o mês da venda.',
                show: true,
            });
            return;
        }

        setLoading(true);

        const [ano, mesNumero] = mes.split('-').map(Number);
        const ultimoDia = new Date(ano, mesNumero, 0).getDate();
        const dataInicio = `${mes}-01`;
        const dataFim = `${mes}-${String(ultimoDia).padStart(2, '0')}`;

        try {
            const response = await fetch(`${baseUrl}/manager/representantes/vendas/novo/${representanteId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                },
                body: JSON.stringify({
                    data_inicio: dataInicio,
                    data_fim: dataFim,
                    quantidade,
                }),
            });

            if (!response.ok) {
                throw new Error('Erro ao cadastrar venda mensal.');
            }

            setMes('');
            setQuantidade('');

            setNotification({
                type: 'success',
                message: 'Venda mensal cadastrada!',
                show: true,
            });

            onSuccess?.();
        } catch (error) {
            setNotification({
                type: 'error',
                message: error.message,
                show: true,
            });
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="flex gap-4 items-end mb-6 flex-col sm:flex-row">
            <div className="w-full sm:w-auto">
                <label className="block text-sm font-medium mb-1">Mês</label>
                <input
                    type="month"
                    value={mes}
                    onChange={(e) => setMes(e.target.value)}
                    className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none"
                />
            </div>

            <div className="w-full sm:w-auto">
                <label className="block text-sm font-medium mb-1">Quantidade</label>
                <input
                    type="number"
                    min="0"
                    value={quantidade}
                    onChange={(e) => setQuantidade(e.target.value)}
                    className="w-full px-3 py-1.5 2xl:py-2 border border-gray-300 rounded-md outline-none focus:border-secondary focus-visible:shadow-none [appearance:textfield] [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:appearance-none"
                />
            </div>

            <button
                type="submit"
                disabled={loading}
                className="bg-secondary text-white py-2 px-4 rounded-md hover:bg-opacity-80 disabled:bg-opacity-80 disabled:cursor-not-allowed w-full sm:w-auto"
            >
                {loading ? (
                    <Loading className="text-white fill-white mx-auto" />
                ) : (
                    <>
                        <FontAwesomeIcon icon={faPlus} className="mr-2" />
                        Adicionar venda
                    </>
                )}
            </button>
        </form>
    );
};

export default SellerAddSale;
